<template>
  <Flex direction="column">
    <BaseCheckbox
      v-model="hasDescription"
      :label="$t('service.description.heading')"
      :info="$t('service.description.description')"
      v-test="'service-description-toggle'"
    />
    <BaseInput
      v-if="hasDescription"
      v-model="description"
      :label="$t('global.description')"
      type="textarea"
      v-test="'service-description'"
    />
  </Flex>
</template>

<script
  lang="ts"
  setup
>
const props = defineProps<{
  modelValue: string;
}>();

const emit = defineEmits<(e: 'update:modelValue', value: string) => void>();

const hasDescription = ref(false);

const description = computed({
  get: () => props.modelValue,
  set: (value: string) => emit('update:modelValue', value),
});

watch(hasDescription, (value: boolean) => {
  if (!value) {
    description.value = '';
  }
});

watch(
  description,
  (value: string) => {
    hasDescription.value = !!value;
  },
  { immediate: true },
);
</script>
